import createPlugin from "./create-plugin.ts";

export default createPlugin({
  name: "transform-react-jsx/development",
  development: true,
});
